<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
        <el-breadcrumb-item>退出学生</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="退出时间" label-width="80px">
          <el-date-picker
            v-model="query.quitTime"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            @change="selList();"
          ></el-date-picker>
        </el-form-item>
        <SelectAbroad v-on:selabroad="function(str){query.abroadTime=str;selList();}"></SelectAbroad>
        <el-form-item label="缴费时间" label-width="80px" style="margin-left:8px;">
          <el-date-picker
            v-model="query.daterange"
            @change="selList()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="顾问" label-width="80px" style="margin-left:-15px;" v-if="userIsAdmain">
          <DeptRoleTeacherSelect v-model="query.adviserID" dept="留学" placeholder="请选择顾问" @change="selList()" />
        </el-form-item>
        <el-form-item label="营销" label-width="80px" style="margin-left:-15px;" v-if="userIsAdmain">
          <DeptRoleTeacherSelect v-model="query.marketID" dept="留学" placeholder="请选择营销" @change="selList()" />
        </el-form-item>
        <el-form-item label="赴日目的" label-width="80px">
          <el-select v-model="query.purpose" clearable filterable placeholder="请选择" @change="selList()">
            <el-option v-for="item in purposeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄阶段" label-width="80px">
          <el-select v-model="query.ageRange" clearable placeholder="请选择" @change="selList()">
            <el-option v-for="item in ageRangeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
             <el-button type="success" @click="exportClick();">导出</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>退出学生列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <el-table-column prop="quitTime" label="退出时间"></el-table-column>
          <el-table-column prop="paymentDate" label="缴费时间"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="abroadDate" label="留学时间"></el-table-column>
          <el-table-column prop="applySchool" label="申请学校"></el-table-column>
          <el-table-column prop="origin" label="来源"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column prop="adviserName" label="顾问"></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>
          <el-table-column prop="documentName" label="文案"></el-table-column>
          <el-table-column prop="exitAmount" label="退出费用"></el-table-column>
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-student="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group v-if="isMarketingOnlyStu(scope.row) || isNoAdviserStu(scope.row)">
                <el-tooltip content="查看" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid=scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看" placement="top">
                  <el-button type="success" size="mini" icon="el-icon-view"
                    @click="showstuid=scope.row.id"></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button type="info" size="mini" icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditStu(scope.row)">
                  <el-button type="primary" size="mini" icon="el-icon-edit"
                    @click="editClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
    <!-- 操作对话框 -->
    <el-dialog :title="form.id>0?'编辑退出学生信息':'添加退出学生信息'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="姓名"
          prop="realName"
          :rules="[
        {required:true,message:'请输入姓名'}
        ]"
        >
          <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="年龄" prop="age">
              <el-input v-model.number="form.age" type="number" placeholder="请输入年龄"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="QQ" prop="qq">
              <el-input v-model="form.qq" placeholder="请输入QQ"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学生/家长" prop="studentType">
              <el-select v-model="form.studentType" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in studentTypeList" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="跟进状态" prop="state" :rules="[{required:true,message:'请选择跟进状态'}]">
              <el-select v-model="form.state" placeholder="请选择跟进状态" filterable>
                <el-option
                  v-for="item in statelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserList"
      :market-list="marketList"
      :user-is-admain="userIsAdmain"
      :show-student="false"
      :show-jap="true"
      :show-mingye="true"
      name-label="学生姓名"
      empty-message="请选择分配给日语或鸣野"
      @success="getList"
    />
    <StudentShow :stuid="showstuid" v-on:setzero="showstuid=0"></StudentShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
import StudentShow from "@/components/StudentShow";
import SelectAbroad from "@/components/SelectAbroad";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";

export default {
  data() {
    return {
      userIsAdmain: user.isAdmin(), //管理员
      userIsAdviser: user.isAdviser(), //顾问老师
      userIsMarket: user.isMarket(), //营销老师
      key: "",
      state: "",
      domain: url.getDomain(),
      query: {state:'f'}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      evalDialogVisible: false,
      eval: {}, //完善地址，下载地址
      submiting: false,
      stuid: 0,
      areaList: [], //地区
      selectedOptions: [],
      statelist: [
        { id: undefined, name: "请选择" },
        { id: "a", name: "a" },
        { id: "b", name: "b" },
        { id: "c", name: "c" },
        { id: "d", name: "d" },
        { id: "e", name: "e" }
      ], //跟进状态
      showstuid: 0,
      quitTimeList:[],//退出时间
      daterange: [], //缴费时间
      adviserList: [], //顾问老师
      marketList: [], //营销老师
      purposeList: url.getStudentPurposeList(), // 赴日目的（筛选用）
      ageRangeList: url.getAgeRangeList(), // 年龄阶段（筛选用）
      studentTypeList: url.getStudentTypeList(), // 学生/家长（编辑用）
      abroadTimeDialog2: false,
      followDialogVisible: false,
      followDialogLoading: false,
      followType: '',
      followDialogRow: null,
      followData: { list: [] },
      followJapHasCourse: false,
      followMingyeDetail: null,
      followDialogTitle: '',
      assignDialogVisible: false, //分配对话框显示
      assignForm: {
        resourceTypes: [] // 分配的资源类型：['日语', '鸣野']
      }, //分配表单
      assignSubmiting: false, //分配提交中
    };
  },
  components: {
    StudentShow,
    SelectAbroad,
    OtherDeptFollow,
    FollowDetailDialog,
    AssignResourceDialog,
    DeptRoleTeacherSelect,
  },
  methods: {
    canEditStu(row) {
      return user.canEditStu(row);
    },
    isMarketingOnlyStu(row) {
      return user.isMarketingOnlyStu(row);
    },
    isNoAdviserStu(row) {
      return user.isNoAdviserStu(row);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = Object.assign({}, _this.query);
      if (_this.query.daterange && _this.query.daterange.length === 2) {
        params.payStart = _this.query.daterange[0];
        params.payEnd = _this.query.daterange[1];
      } else {
        delete params.payStart;
        delete params.payEnd;
      }
      // 退出时间：后端按 quitTimeStart/quitTimeEnd 筛选，将选中的月份转为当月首日至下月首日
      if (_this.query.quitTime) {
        var qt = _this.query.quitTime;
        params.quitTimeStart = qt + "-01";
        var y = parseInt(qt.substring(0, 4), 10);
        var m = parseInt(qt.substring(5, 7), 10);
        var nextY = m === 12 ? y + 1 : y;
        var nextM = m === 12 ? 1 : m + 1;
        params.quitTimeEnd = nextY + "-" + (nextM < 10 ? "0" : "") + nextM + "-01";
      } else {
        delete params.quitTimeStart;
        delete params.quitTimeEnd;
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      params.state = "f";
      var link = url.getStu("getlist_base");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //按状态查询
    stateClick: function() {
      this.getList();
    },
    //搜索查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },

    //获取地区数据
    getData() {
      var _this = this;
      var link = url.getCommon("getareajson");
      // $.getJSON(link, data => {
      //   _this.areaList = data;
      // });
      // 顾问/营销老师：不再按板块获取，直接获取所有启用用户
      $.get(url.getStu("getenableusers"), res => {
        var list = res || [];
        _this.adviserList = list;
        _this.marketList = list;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getStu("addorupdate_base");
      var info = this.form;
      info.provinceID = this.selectedOptions[0];
      info.cityID = this.selectedOptions[1];
      info.countyID = this.selectedOptions[2];

      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
      this.selectedOptions = [row.provinceID, row.cityID, row.countyID];
    },
    //跳转详情
    goTo: function(id) {
      this.$router.push({
        name: "follow",
        query: { id: id }
      });
    },
    //跳转评估表
    tabClick: function(id) {
      var _this = this;
      _this.evalDialogVisible = true;
      var link = url.getStu("getlink");
      $.get(link, { id: id }, data => {
        _this.eval = data;
      });
    },
    //删除
    delClick: function(row) {
      var _this = this;
      var link = url.getStu("delete_base"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { idList: id }, res => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
        //导出操作
    exportClick() {
      var _this = this;
      var params = _this.query;
      params.key = _this.key;

      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
       result.push('exportName=退出学生列表');
      var link = url.getStu("ExportVip") + "?" + result.join("&");
      //console.info(link);
      window.open(link, "_blank");
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row && (row.id != null || row.studentID != null) ? { ...row, id: row.id || row.studentID } : (row || {});
      this.followDialogVisible = true;
    },
    assignClick(row) {
      if (!row) return;
      this.assignForm = {
        studentID: row.id || row.studentID,
        realName: row.realName || '',
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: row.isMingye || false,
        resourceTypes: [],
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: row.jpMarketID || null,
        myAdviserID: row.myAdviserID || null,
        myMarketID: row.myMarketID || null
      };
      this.assignDialogVisible = true;
    },
  },
  created() {},
  mounted() {
    //获取服务器列表
    this.getList();
    this.getData();
  }
};
</script>


